import Vue from 'vue'
import App from './App.vue'
import ajax from "./assets/js/axios/index";
import router from "./router";
import "./assets/css/style.css";
 
import "./assets/css/element.css";
import "./assets/iconfont/iconfont.js";
import ElementUI from 'element-ui';

import dgUI from "./components/index";
import wow from 'wowjs'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  preLoad: 1.3, //预加载的宽高比
  // loading: loadimage, //图片加载状态下显示的图片
  // error: errorimage, //图片加载失败时显示的图片
  attempt: 1, // 加载错误后最大尝试次数
})
Vue.prototype.$wow = wow
window.ajax = ajax;
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(dgUI);
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
